import { ChevronRight, Shield, User } from "lucide-react";

const BADGE = `${import.meta.env.BASE_URL}images/connectid/connectid-verified-grey.svg`;

export function FlowStrip() {
  return (
    <div className="relative" data-testid="flow-strip">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-6 items-start">
        {/* Step 1: Staff create */}
        <div className="relative flex flex-col">
          <div className="h-[200px] w-full rounded-[4px] border border-[hsl(var(--brand-sand))] bg-white overflow-hidden flex flex-col shadow-sm mb-6">
            <div className="h-6 border-b border-[hsl(var(--brand-sand))] bg-[hsl(var(--brand-bone))] flex items-center px-2 gap-1.5 justify-between">
              <div className="flex gap-1.5">
                <div className="w-2 h-2 rounded-full bg-[hsl(var(--brand-sand))]"></div>
                <div className="w-2 h-2 rounded-full bg-[hsl(var(--brand-sand))]"></div>
                <div className="w-2 h-2 rounded-full bg-[hsl(var(--brand-sand))]"></div>
              </div>
              <span
                className="font-display font-semibold text-[9px] tracking-tight leading-none text-[hsl(var(--brand-charcoal))]"
                style={{ letterSpacing: "-0.02em" }}
              >
                Fortify<span className="text-[hsl(var(--brand-forest))]">ID</span>
              </span>
            </div>
            <div className="p-3 flex-1 flex flex-col gap-2">
              <div className="text-[10px] font-medium text-[hsl(var(--brand-charcoal))] border-b border-[hsl(var(--brand-sand))] pb-1 mb-1">New request</div>
              <div className="flex gap-1">
                <div className="h-4 w-12 rounded-[2px] bg-[hsl(var(--brand-bone))] border border-[hsl(var(--brand-sand))] flex items-center justify-center text-[7px] text-[hsl(var(--brand-slate))]">Bank details</div>
                <div className="h-4 w-10 rounded-[2px] bg-white border border-[hsl(var(--brand-sand))] flex items-center justify-center text-[7px] text-[hsl(var(--brand-slate))]">Contact</div>
              </div>
              <div className="mt-1">
                <div className="text-[8px] text-[hsl(var(--brand-slate))] mb-1">Client</div>
                <div className="h-6 w-full rounded-[2px] border border-[hsl(var(--brand-sand))] flex items-center px-2 text-[9px] text-[hsl(var(--brand-charcoal))]">
                  <User size={10} className="mr-1 text-[hsl(var(--brand-slate))]" /> Jane Doe
                </div>
              </div>
              <div className="mt-1 flex items-center justify-between">
                <div className="text-[8px] text-[hsl(var(--brand-slate))] flex items-center gap-1">
                  <Shield size={8} /> ConnectID® Verification
                </div>
                <div className="w-6 h-3 rounded-full bg-[hsl(var(--brand-forest))] relative">
                  <div className="w-2 h-2 bg-white rounded-full absolute right-0.5 top-0.5"></div>
                </div>
              </div>
              <div className="mt-auto h-5 bg-[hsl(var(--brand-forest))] rounded-[2px] flex items-center justify-center text-[8px] text-white">Send Request</div>
            </div>
          </div>
          <div className="text-[11px] font-mono tracking-[0.18em] text-[hsl(var(--brand-brass))] mb-2">01</div>
          <h3 className="text-base font-semibold text-[hsl(var(--brand-charcoal))] mb-1">Staff create</h3>
          <p className="text-sm text-[hsl(var(--brand-slate))] leading-relaxed">Pick the change type, choose the client, toggle ID verification.</p>
        </div>

        {/* Step 2: Client lands */}
        <div className="relative flex flex-col">
          <div className="hidden lg:flex absolute top-[100px] -left-[18px] -translate-y-1/2 -translate-x-1/2 z-10 bg-[hsl(var(--brand-bone))] rounded-full border border-[hsl(var(--brand-sand))] w-6 h-6 items-center justify-center">
            <ChevronRight size={12} className="text-[hsl(var(--brand-brass))]" />
          </div>
          <div className="h-[170px] w-[90px] mx-auto mt-[30px] rounded-[12px] border-[3px] border-[hsl(var(--brand-sand))] bg-white overflow-hidden flex flex-col shadow-sm mb-6 relative">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-10 h-3 bg-[hsl(var(--brand-sand))] rounded-b-[4px]"></div>
            <div className="p-3 pt-6 flex-1 flex flex-col items-center text-center">
              <div className="w-6 h-6 rounded bg-[hsl(var(--brand-charcoal))] text-white flex items-center justify-center text-[10px] font-bold mb-3">AC</div>
              <div className="text-[10px] font-semibold text-[hsl(var(--brand-charcoal))] mb-1">ACME Corp</div>
              <div className="text-[8px] text-[hsl(var(--brand-slate))] mb-4 leading-tight">needs to verify your identity to update your details.</div>
              <div className="w-full bg-[hsl(var(--brand-bone))] border border-[hsl(var(--brand-sand))] rounded-[4px] p-2 flex flex-col items-center gap-1 mb-auto">
                <Shield size={12} className="text-[hsl(var(--brand-forest))]" />
                <div className="text-[7px] text-[hsl(var(--brand-forest))] font-semibold">Secure verification</div>
              </div>
              <div className="w-full h-7 bg-[#0047BB] rounded-[4px] flex items-center justify-center mt-3 gap-1">
                <div className="text-[9px] text-white font-medium">Verify with ConnectID</div>
              </div>
            </div>
          </div>
          <div className="text-[11px] font-mono tracking-[0.18em] text-[hsl(var(--brand-brass))] mb-2">02</div>
          <h3 className="text-base font-semibold text-[hsl(var(--brand-charcoal))] mb-1">Client lands</h3>
          <p className="text-sm text-[hsl(var(--brand-slate))] leading-relaxed">Their own bank app branding — never a generic third-party form.</p>
        </div>

        {/* Step 3: Verify & submit */}
        <div className="relative flex flex-col">
          <div className="hidden lg:flex absolute top-[100px] -left-[18px] -translate-y-1/2 -translate-x-1/2 z-10 bg-[hsl(var(--brand-bone))] rounded-full border border-[hsl(var(--brand-sand))] w-6 h-6 items-center justify-center">
            <ChevronRight size={12} className="text-[hsl(var(--brand-brass))]" />
          </div>
          <div className="h-[170px] w-[90px] mx-auto mt-[30px] rounded-[12px] border-[3px] border-[hsl(var(--brand-sand))] bg-[hsl(var(--brand-bone))] overflow-hidden flex flex-col shadow-sm mb-6 relative">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-10 h-3 bg-[hsl(var(--brand-sand))] rounded-b-[4px]"></div>
            <div className="p-3 pt-6 flex-1 flex flex-col">
              <div className="flex justify-center mb-2">
                <img
                  src={BADGE}
                  alt="Verified with ConnectID"
                  width={144}
                  height={24}
                  style={{ height: 12, width: "auto" }}
                  className="shrink-0"
                />
              </div>
              <div className="text-[10px] font-semibold text-[hsl(var(--brand-charcoal))] mb-2">Bank Details</div>
              <div className="flex flex-col gap-1.5 mb-auto">
                <div>
                  <div className="text-[6px] text-[hsl(var(--brand-slate))] mb-0.5">Full name (Verified)</div>
                  <div className="h-5 w-full bg-white border border-[hsl(var(--brand-sand))] rounded-[2px] px-1.5 flex items-center text-[8px] text-[hsl(var(--brand-charcoal))] font-medium">Jane Doe</div>
                </div>
                <div>
                  <div className="text-[6px] text-[hsl(var(--brand-slate))] mb-0.5">BSB</div>
                  <div className="h-5 w-full bg-white border border-[hsl(var(--brand-sand))] rounded-[2px] px-1.5 flex items-center text-[8px] text-[hsl(var(--brand-charcoal))]">062-000</div>
                </div>
                <div>
                  <div className="text-[6px] text-[hsl(var(--brand-slate))] mb-0.5">Account Number</div>
                  <div className="h-5 w-full bg-white border border-[hsl(var(--brand-sand))] rounded-[2px] px-1.5 flex items-center text-[8px] text-[hsl(var(--brand-charcoal))]">1234 5678</div>
                </div>
              </div>
              <div className="w-full h-7 bg-[hsl(var(--brand-forest))] rounded-[4px] flex items-center justify-center mt-3">
                <div className="text-[9px] text-white font-medium">Submit Details</div>
              </div>
            </div>
          </div>
          <div className="text-[11px] font-mono tracking-[0.18em] text-[hsl(var(--brand-brass))] mb-2">03</div>
          <h3 className="text-base font-semibold text-[hsl(var(--brand-charcoal))] mb-1">Verify & submit</h3>
          <p className="text-sm text-[hsl(var(--brand-slate))] leading-relaxed">ConnectID identity check, then a structured form. No PDFs.</p>
        </div>

        {/* Step 4: Review & complete */}
        <div className="relative flex flex-col">
          <div className="hidden lg:flex absolute top-[100px] -left-[18px] -translate-y-1/2 -translate-x-1/2 z-10 bg-[hsl(var(--brand-bone))] rounded-full border border-[hsl(var(--brand-sand))] w-6 h-6 items-center justify-center">
            <ChevronRight size={12} className="text-[hsl(var(--brand-brass))]" />
          </div>
          <div className="h-[200px] w-full rounded-[4px] border border-[hsl(var(--brand-sand))] bg-white overflow-hidden flex flex-col shadow-sm mb-6">
            <div className="h-6 border-b border-[hsl(var(--brand-sand))] bg-[hsl(var(--brand-bone))] flex items-center px-2 gap-1.5 justify-between">
              <div className="flex items-center gap-1.5">
                <div className="flex gap-1">
                  <div className="w-2 h-2 rounded-full bg-[hsl(var(--brand-sand))]"></div>
                  <div className="w-2 h-2 rounded-full bg-[hsl(var(--brand-sand))]"></div>
                  <div className="w-2 h-2 rounded-full bg-[hsl(var(--brand-sand))]"></div>
                </div>
                <span
                  className="font-display font-semibold text-[9px] tracking-tight leading-none text-[hsl(var(--brand-charcoal))] ml-1"
                  style={{ letterSpacing: "-0.02em" }}
                >
                  Fortify<span className="text-[hsl(var(--brand-forest))]">ID</span>
                </span>
              </div>
              <div className="h-3 px-1.5 bg-[hsl(var(--brand-forest))]/10 text-[hsl(var(--brand-forest))] text-[6px] font-bold uppercase rounded-[2px] flex items-center">Complete</div>
            </div>
            <div className="p-3 flex-1 flex flex-col gap-2">
              <div className="flex items-center gap-2 border-b border-[hsl(var(--brand-sand))] pb-2">
                <div className="w-6 h-6 rounded-full bg-[hsl(var(--brand-bone))] flex items-center justify-center text-[hsl(var(--brand-slate))]">
                  <User size={10} />
                </div>
                <div>
                  <div className="text-[9px] font-semibold text-[hsl(var(--brand-charcoal))]">Jane Doe</div>
                  <div className="text-[7px] text-[hsl(var(--brand-slate))]">Bank details update</div>
                </div>
              </div>
              <div className="flex-1 flex flex-col gap-3 relative pl-3 mt-1">
                <div className="absolute left-[3px] top-1 bottom-1 w-[1px] bg-[hsl(var(--brand-sand))]"></div>
                <div className="relative pl-3">
                  <div className="absolute -left-[1px] top-1 w-2 h-2 rounded-full bg-[hsl(var(--brand-forest))] border border-white"></div>
                  <div className="text-[8px] font-medium text-[hsl(var(--brand-charcoal))]">Details updated</div>
                  <div className="text-[6px] text-[hsl(var(--brand-slate))]">2 mins ago</div>
                </div>
                <div className="relative pl-3">
                  <div className="absolute -left-[1px] top-1 w-2 h-2 rounded-full bg-[hsl(var(--brand-forest))] border border-white"></div>
                  <img
                    src={BADGE}
                    alt="Verified with ConnectID"
                    width={144}
                    height={24}
                    style={{ height: 11, width: "auto" }}
                    className="shrink-0 mb-0.5"
                  />
                  <div className="text-[6px] text-[hsl(var(--brand-slate))]">3 mins ago</div>
                </div>
                <div className="relative pl-3">
                  <div className="absolute -left-[1px] top-1 w-2 h-2 rounded-full bg-[hsl(var(--brand-sand))] border border-white"></div>
                  <div className="text-[8px] font-medium text-[hsl(var(--brand-charcoal))]">Request sent</div>
                  <div className="text-[6px] text-[hsl(var(--brand-slate))]">5 mins ago</div>
                </div>
              </div>
            </div>
          </div>
          <div className="text-[11px] font-mono tracking-[0.18em] text-[hsl(var(--brand-brass))] mb-2">04</div>
          <h3 className="text-base font-semibold text-[hsl(var(--brand-charcoal))] mb-1">Review & complete</h3>
          <p className="text-sm text-[hsl(var(--brand-slate))] leading-relaxed">Mismatches surfaced, comments threaded, audit-ready.</p>
        </div>
      </div>
    </div>
  );
}
